const itemTypePlaceholderImages = {
	'ARM-WARMER': '/images/itemPlaceHolders/arm-warmer.png',
	'BACK-PACK': '/images/itemPlaceHolders/back-pack.png',
	BAG: '/images/itemPlaceHolders/bag.png',
	'BASE-LAYER': '/images/itemPlaceHolders/base-layer.png',
	'BIB-SHORT': '/images/itemPlaceHolders/bib-short.png',
	'BIB-TIGHT': '/images/itemPlaceHolders/bib-tight.png',
	BIDON: '/images/itemPlaceHolders/bidon.png',
	BMX: '/images/itemPlaceHolders/bmx.png',
	BOTTLE: '/images/itemPlaceHolders/bottle.png',
	BRA: '/images/itemPlaceHolders/bra.png',
	BRAKE: '/images/itemPlaceHolders/brake.png',
	CAP: '/images/itemPlaceHolders/cap.png',
	CASE: '/images/itemPlaceHolders/case.png',
	CASSETTE: '/images/itemPlaceHolders/cassette.png',
	'CHAIN-SET': '/images/itemPlaceHolders/chain-set.png',
	CHAIN: '/images/itemPlaceHolders/chain.png',
	'COMMUTER-BIKE': '/images/itemPlaceHolders/commuter-bike.png',
	COMPUTER: '/images/itemPlaceHolders/computer.png',
	CREAM: '/images/itemPlaceHolders/cream.png',
	'CYCLOCROSS-BIKE': '/images/itemPlaceHolders/cyclocross-bike.png',
	DEFAULT: '/images/itemPlaceHolders/default.png',
	DRIVETRAIN: '/images/itemPlaceHolders/drivetrain.png',
	EYEWEAR: '/images/itemPlaceHolders/eyewear.png',
	FRAME: '/images/itemPlaceHolders/frame.png',
	'FULL-SUSPENSION-MOUNTAIN-BIKE': '/images/itemPlaceHolders/full-suspension-mountain-bike.png',
	GEARS: '/images/itemPlaceHolders/gears.png',
	GILET: '/images/itemPlaceHolders/gilet.png',
	GLASSES: '/images/itemPlaceHolders/glasses.png',
	GLOVE: '/images/itemPlaceHolders/glove.png',
	GOGGLE: '/images/itemPlaceHolders/goggle.png',
	GPS: '/images/itemPlaceHolders/gps.png',
	HANDLEBAR: '/images/itemPlaceHolders/handlebar.png',
	'HARD-TAIL-MOUNTAIN-BIKE': '/images/itemPlaceHolders/hard-tail-mountain-bike.png',
	HELMET: '/images/itemPlaceHolders/helmet.png',
	'INNER-TUBE': '/images/itemPlaceHolders/inner-tube.png',
	JACKET: '/images/itemPlaceHolders/jacket.png',
	'JERSEY-AND-BIB-SHORT': '/images/itemPlaceHolders/jersey-and-bib-short.png',
	JERSEY: '/images/itemPlaceHolders/jersey.png',
	JUMPER: '/images/itemPlaceHolders/jumper.png',
	'KIDS-BIKE': '/images/itemPlaceHolders/kids-bike.png',
	KIT: '/images/itemPlaceHolders/kit.jpg',
	'KNEE-WARMERS': '/images/itemPlaceHolders/knee-warmers.png',
	'LEG-WARMERS': '/images/itemPlaceHolders/leg-warmers.png',
	'LONG-SLEEVE-JERSEY': '/images/itemPlaceHolders/long-sleeve-jersey.png',
	'NECK-WARMER': '/images/itemPlaceHolders/neck-warmer.png',
	OIL: '/images/itemPlaceHolders/oil.png',
	PANT: '/images/itemPlaceHolders/pant.png',
	PEDALS: '/images/itemPlaceHolders/pedals.png',
	'PHONE-POCKET': '/images/itemPlaceHolders/phone-pocket.png',
	PHONE: '/images/itemPlaceHolders/phone.png',
	POUCH: '/images/itemPlaceHolders/pouch.png',
	PUMP: '/images/itemPlaceHolders/pump.png',
	'PUNCTURE-REPAIR': '/images/itemPlaceHolders/puncture-repair.png',
	'ROAD-BIKE-DISC': '/images/itemPlaceHolders/road-bike-disc.png',
	'ROAD-BIKE': '/images/itemPlaceHolders/road-bike.png',
	'SADDLE-BAG': '/images/itemPlaceHolders/saddle-bag.png',
	SADDLE: '/images/itemPlaceHolders/saddle.png',
	'SEAT-POST': '/images/itemPlaceHolders/seat-post.png',
	'SHOE-COVER': '/images/itemPlaceHolders/shoe-cover.png',
	SHOE: '/images/itemPlaceHolders/shoe.png',
	'SHORT-SLEEVE-JERSEY': '/images/itemPlaceHolders/short-sleeve-jersey.png',
	SHORT: '/images/itemPlaceHolders/short.png',
	'SINGLE-SPEED-BIKE': '/images/itemPlaceHolders/single-speed-bike.png',
	SKINSUIT: '/images/itemPlaceHolders/skinsuit.png',
	'SLEEPING-BAG': '/images/itemPlaceHolders/sleeping-bag.png',
	SOCK: '/images/itemPlaceHolders/sock.png',
	'SPORTS-BRA': '/images/itemPlaceHolders/sports-bra.png',
	STEERING: '/images/itemPlaceHolders/steering.png',
	STEMS: '/images/itemPlaceHolders/stems.png',
	SUNGLASSES: '/images/itemPlaceHolders/sunglasses.png',
	SWEATER: '/images/itemPlaceHolders/sweater.png',
	SWEATPANT: '/images/itemPlaceHolders/sweatpant.png',
	'T-SHIRT': '/images/itemPlaceHolders/t-shirt.png',
	'TANK-TOP': '/images/itemPlaceHolders/tank-top.png',
	'THERMAL-BIB-TIGHT': '/images/itemPlaceHolders/thermal-bib-tight.png',
	TIGHT: '/images/itemPlaceHolders/tight.png',
	TOOLS: '/images/itemPlaceHolders/tools.png',
	'TRACK-BIKE': '/images/itemPlaceHolders/track-bike.png',
	TROUSER: '/images/itemPlaceHolders/trouser.png',
	'TURBO-TRAINER': '/images/itemPlaceHolders/turbo-trainer.png',
	TYRE: '/images/itemPlaceHolders/tyre.png',
	UNDERWEAR: '/images/itemPlaceHolders/underwear.png',
	'URBAN-BIKE': '/images/itemPlaceHolders/urban-bike.png',
	VEST: '/images/itemPlaceHolders/vest.png',
	WALLET: '/images/itemPlaceHolders/wallet.png',
	WATCH: '/images/itemPlaceHolders/watch.png',
	'WATER-BOTTLE': '/images/itemPlaceHolders/water-bottle.png',
	WHEEL: '/images/itemPlaceHolders/wheel.png'
}


export const getPlaceholderImageUrl = itemType => itemTypePlaceholderImages[itemType] || itemTypePlaceholderImages.DEFAULT

export default itemTypePlaceholderImages



// WEBPACK FOOTER //
// ./src/enums/itemTypePlaceholderImages.js